<div class="hero-image-carousel">
  <!-- Image Carousel Swiper -->
  <swiper #heroImageCarouselSwiper [config]="swiperConfig">
    @for (item of block.content; track trackById(i, item); let i = $index) {
      <div class="hero-image-carousel-slide" swiperSlide>
        <img [src]="getSlideImgUrl(item.data.image)" [alt]="item.data.altText" />
      </div>
    }
  </swiper>

  <div>
    <!-- Left Chevron -->
    <div class="swiper-button-hero-image-carousel swiper-button-hero-image-carousel-prev">
      <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.004 3.67111L18.6478 0.33374L0 19.0004L18.6667 37.6671L22.004 34.3297L6.67475 19.0004L22.004 3.67111Z"
          fill="white" />
      </svg>
    </div>

    <!-- Right Chevron -->
    <div class="swiper-button-hero-image-carousel swiper-button-hero-image-carousel-next">
      <svg width="23" height="38" viewBox="0 0 23 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.666626 34.3297L4.02286 37.6671L22.6707 19.0004L4.004 0.33374L0.666626 3.67112L15.9959 19.0004L0.666626 34.3297Z"
          fill="white" />
      </svg>
    </div>
  </div>
</div>
